"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseui = require("baseui");

var _propTypes = require("prop-types");

var _typography = require("../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LeftPane = (0, _baseui.styled)('div', {
  flexGrow: '1',
  flexShrink: '1',
  flexBasis: '30%'
});
var RightPane = (0, _baseui.styled)('div', {
  flexGrow: '3',
  flexShrink: '1',
  flexBasis: '70%'
});
var Limiter = (0, _baseui.styled)('div', function (_ref) {
  var $theme = _ref.$theme;
  return {
    maxWidth: "".concat(1.25 * $theme.breakpoints.medium, "px")
  };
});
var Root = (0, _baseui.styled)('div', function (_ref2) {
  var $theme = _ref2.$theme;
  var breakpoints = $theme.breakpoints,
      sizing = $theme.sizing;
  return _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: sizing.scale800,
    paddingBottom: sizing.scale800
  }, "@media screen and (min-width: ".concat(breakpoints.medium, "px)"), {
    flexDirection: 'row'
  });
});

var Section = function Section(_ref4) {
  var label = _ref4.label,
      children = _ref4.children;
  return _react["default"].createElement(Root, null, _react["default"].createElement(LeftPane, null, _react["default"].createElement(_typography.H2, null, label)), _react["default"].createElement(RightPane, null, _react["default"].createElement(Limiter, null, children)));
};

exports.Section = Section;
Section.propTypes = {
  label: _propTypes.node.isRequired,
  children: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]).isRequired
};